module.exports = __webpack_public_path__ + "img/09_Steuerung@2x.042a85f6.jpg";